import { getFeature } from 'Cloud/Application/FeaturesEs6';

export type NestleResultList = Array<{
    type: string;
    names: string[];
}>;

export const nestleResultListCat: NestleResultList | undefined = getFeature('nestle-result-list-cats');
export const nestleResultListDog: NestleResultList | undefined = getFeature('nestle-result-list-dogs');

export const nestleGroupLink: string | undefined = getFeature('nestle-group-link') || 'https://vk.com/mailru';

export const nestlePetsCardList: string[] | undefined = getFeature('nestle-pets-cards-list');
export const nestlePetsMobileCardList: string[] | undefined = getFeature('nestle-pets-cards-mobile-list');

type TariffList = {
    year: string[];
    month: string[];
};

export const nestleTariffList: TariffList = getFeature('nestle-tariff-list') || {
    year: [
        'W1TB_1y_nestle_special_project_discount',
        'W256GB_1y_nestle_special_project_discount',
        'W512GB_1y_nestle_special_project_family_features_discount',
        'W1TB_1y_nestle_special_project_family_features_discount',
    ],
    month: [
        'W1TB_1m_nestle_special_project',
        'W256GB_1m_nestle_special_project',
        'W512GB_1m_nestle_special_project_family_features',
        'W1TB_1m_nestle_special_project_family_features',
    ],
};
